import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-157">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-158">
        {/* Wordmark */}
        <a href="#home" className="text-2xl md:text-3xl font-heading text-brand-light tracking-wider z-50 relative" data-id="element-159">
          THE VALLEY <span className="text-brand-orange" data-id="element-160">GROOMING</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-161">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-light font-medium hover:text-brand-orange transition-colors relative group" data-id="element-162">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-orange transition-all duration-300 group-hover:w-full" data-id="element-163"></span>
            </a>)}
          <a href="#book" className="bg-brand-orange text-brand-light px-6 py-2.5 rounded-full font-semibold hover:bg-orange-600 hover:box-glow transition-all duration-300" data-id="element-164">
            Book Now
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-brand-light z-50 relative p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-165">
          {mobileMenuOpen ? <X size={28} data-id="element-166" /> : <Menu size={28} data-id="element-167" />}
        </button>

        {/* Mobile Menu */}
        <div className={`fixed inset-0 bg-brand-dark flex flex-col items-center justify-center gap-8 transition-transform duration-300 ease-in-out ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`} data-id="element-168">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-2xl font-heading text-brand-light hover:text-brand-orange transition-colors" data-id="element-169">
              {link.name}
            </a>)}
          <a href="#book" onClick={() => setMobileMenuOpen(false)} className="bg-brand-orange text-brand-light px-8 py-4 rounded-full font-heading text-xl w-[80%] text-center mt-4" data-id="element-170">
            Book Now
          </a>
        </div>
      </div>
    </header>;
}